/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useComposerMode } from "cms/components/hooks/use-composer-mode";
import { AddComponent } from "cms/components/layout/add-component/add-component";
import { Fragment } from "react";
import { useModelNamedComponentsField } from "hooks/useModelNamedComponentsField";

const AddComponentBar = (props) => {

    const field = props?.field;
    const fieldName = field?.name;
    const { editMode, contentOnly } = useComposerMode();
    const components = useModelNamedComponentsField(fieldName);
    const count = components?.length;
    // only show component bar for empty fields
    // otherwise, components are added from side panel or in place
    const showAdd = count === 0;

    return (
        <Fragment>
            {editMode && !contentOnly && showAdd && (
                <div className='component-bar'>
                    <AddComponent
                        fieldName={fieldName}
                        isLineButton={false}
                    />
                </div>
            )}
        </Fragment>
    );
};

export { AddComponentBar };
